module.exports = __webpack_public_path__ + "static/media/2fa-zh-CN.e1c1caf8.png";